/** Wiki: https://wiki.easydevel.com/books/camper-eshop/page/visualizador-3d */
import { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { Modal } from 'antd';
import { bool, string } from 'prop-types';

import { useI18n } from 'context/i18n';
import { BoxThreeDSVG } from 'components/iconsSVG/box-3d';
import { track3D } from 'utils/dataLayers';

import styles from './style.module.css';

const Viewer = dynamic(() => import('./viewer').then((mod) => mod.Viewer3D), { ssr: false });

export function Desktop3D({ code = '' }) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const hasSentEvent = useRef(false);

  const onClick = () => {
    setOpen(true);
    if (!hasSentEvent.current) {
      hasSentEvent.current = true;
      track3D(code);
    }
  };

  return (
    <div className="max-md:hidden">
      <button className={styles.modalButton} onClick={onClick}>
        {t('ficha.producto', '3d.viewer')}
        <BoxThreeDSVG />
      </button>
      <Modal
        visible={open}
        footer={null}
        onCancel={() => setOpen(false)}
        closeIcon={
          <svg height="24" width="24" viewBox="0 0 18 18">
            <g fill="none" stroke="currentColor" strokeWidth={2} fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
              <path d="m16.664783 17.163575-15.664783-15.663441"></path>
              <path d="m16.664783 1.5-15.664783 15.663441"></path>
            </g>
          </svg>
        }
        className={styles.modal}
        width="100%"
        wrapClassName="z-[99999999]"
      >
        <Viewer code={code} />
      </Modal>
    </div>
  );
}
